import { render, staticRenderFns } from "./user-add.vue?vue&type=template&id=5f6b9bdb&scoped=true&"
import script from "./user-add.vue?vue&type=script&lang=js&"
export * from "./user-add.vue?vue&type=script&lang=js&"
import style0 from "./user-add.vue?vue&type=style&index=0&id=5f6b9bdb&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=5f6b9bdb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6b9bdb",
  null
  
)

component.options.__file = "user-add.vue"
export default component.exports